// GENERATED FILE — DO NOT EDIT.
// Source of truth: public.estimate_statuses (see migration 20260824100100).
// Regenerate: npm run estimate-status:sync
//
// Hand-editing this file re-creates the bug the invoice version exists to prevent:
// a status list maintained by hand in several apps drifts, and the app that has not
// heard of a status guesses wrong about what it means.

export type EstimateStatus = 'draft' | 'sent' | 'viewed' | 'changes_requested' | 'approved' | 'declined' | 'expired' | 'converted' | 'archived';

export const ESTIMATE_STATUSES: readonly EstimateStatus[] = ['draft', 'sent', 'viewed', 'changes_requested', 'approved', 'declined', 'expired', 'converted', 'archived'] as const;

/** Settled. Nothing transitions out of these. */
const TERMINAL: ReadonlySet<EstimateStatus> = new Set(['declined', 'converted', 'archived']);

/** Still in the pipeline — counts toward open estimate value. */
const OPEN: ReadonlySet<EstimateStatus> = new Set(['sent', 'viewed', 'changes_requested']);

/** We are waiting on the customer. Drives follow-up nudges. */
const AWAITING_CUSTOMER: ReadonlySet<EstimateStatus> = new Set(['sent', 'viewed']);

/** The public /e/:token page may render in this status. */
const CUSTOMER_VISIBLE: ReadonlySet<EstimateStatus> = new Set(['sent', 'viewed', 'approved', 'declined', 'expired', 'converted']);

/**
 * Settled. Nothing transitions out of these.
 */
export function isTerminal(status: EstimateStatus): boolean {
  return TERMINAL.has(status);
}

/**
 * Still in the pipeline — counts toward open estimate value.
 */
export function isOpen(status: EstimateStatus): boolean {
  return OPEN.has(status);
}

/**
 * Are we waiting on the customer to act?
 *
 * This is what a follow-up nudge must key off — NOT isOpen(). `changes_requested`
 * is open, but the ball is ours: chasing a customer who already asked for a change
 * is how you lose the job.
 */
export function isAwaitingCustomer(status: EstimateStatus): boolean {
  return AWAITING_CUSTOMER.has(status);
}

/**
 * May the customer load the public estimate link in this status?
 *
 * Never re-derive this as `status !== 'draft'`. Archived estimates and estimates
 * withdrawn for changes must 404 too.
 */
export function isCustomerVisible(status: EstimateStatus): boolean {
  return CUSTOMER_VISIBLE.has(status);
}
